<p-card [header]="property.name" class="building-item m-3" [routerLink]="getRoute(config.type)" [queryParams]="{'uuid': property.uuid}">
    <ng-template pTemplate="header">
        <img *ngIf="property.main_image && !loading" [src]="property.main_image.data" [alt]="property.main_image.alt" class="property-image" />
        <p-skeleton *ngIf="!property.main_image || loading" height="157px"></p-skeleton>
    </ng-template>
    <p class="orange">
        <i class="pi pi-map-marker"></i>{{property.location}} <strong>{{property.rooms}} Habs {{property.bathrooms}} baths</strong>
    </p>
    <p>
        Periódo de inversión <strong>{{property.investment_time}} meses</strong>
    </p>
    <p>
        Rentabilidad total estimada <strong>{{property.total_return}}%</strong>
    </p>
    <p>
        Rentabilidad anual alquiler <strong>{{property.annual_rent_return}}%</strong>
    </p>
    <div class="progress blue" *ngIf="property.state == 'studying'">
        <p class="location ">
            <i class="pi pi-question"></i>En Estudio
        </p>
        <p-progressBar  mode="indeterminate" [style]="{'height': '12px'}"></p-progressBar>
    </div>
    <div class="progress green" *ngIf="property.state == 'in_progress'">
        <p class="location ">
            <i class="pi pi-check"></i>En Progreso
        </p>
        <p-progressBar mode="indeterminate" [style]="{'height': '12px'}"></p-progressBar>
    </div>
    <div class="progress red" *ngIf="property.state == 'finished'">
        <p class="location ">
            <i class="pi pi-flag-fill"></i>Finalizado
        </p>
        <p-progressBar value="100" [style]="{'height': '12px'}"></p-progressBar>
    </div>

</p-card>
